import React, { useState, useEffect, useContext } from 'react';
import './footer.css';
import { CheckoutContext } from '../CheckoutContainer';

const FooterPage = () => {
  const year = new Date().getFullYear();
  const [phoneNumber, setPhoneNumber] = useState('(832) 979-7034');
  const [instagramLink, setInstagramLink] = useState('https://www.instagram.com/luxemobileiv');
  const { checkoutData } = useContext(CheckoutContext);
  const selectedCityId = checkoutData && checkoutData.cityID != null ? parseInt(checkoutData.cityID, 10) : undefined;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // const storedCityID = localStorage.getItem('cityID');

      // const url = window.location.href.toLowerCase();
      if (selectedCityId === 4) {
        setPhoneNumber('(956) 413-2356');
        setInstagramLink('https://www.instagram.com/luxemobileivrgv');
      } else if (selectedCityId === 5) {
        setPhoneNumber('(720) 797-5461');
        setInstagramLink('https://www.instagram.com/luxemobileiv');
      } else if (selectedCityId === 2) {
        setPhoneNumber('(737) 325-8075');
        setInstagramLink('https://www.instagram.com/luxemobileiv');
      } else if (selectedCityId === 6) {
        setPhoneNumber('(210) 941-1846');
        setInstagramLink('https://www.instagram.com/luxemobileiv');
      } else if (selectedCityId === 7) {
        setPhoneNumber('(629) 205-6873');
        setInstagramLink('https://www.instagram.com/luxemobileiv');
      } else if (selectedCityId === 9) {
        setPhoneNumber('(773) 492-8227');
        setInstagramLink('https://www.instagram.com/luxemobileiv');
      } else if (selectedCityId === 8) {
        setPhoneNumber('(469) 658-8829');
        setInstagramLink('https://www.instagram.com/luxemobileiv');
      } else {
        // Default to Houston
        setPhoneNumber('(832) 979-7034');
        setInstagramLink('https://www.instagram.com/luxemobileiv');
      }
    }
  }, [selectedCityId]);

  return (
    <section className="footer" id="footer">
      <div className="footer-container">
        <div className="footer-column-large">
          <h2 className="footer-title">Luxe Mobile IV</h2>
        </div>
        <div className="footer-column">
          <h5 className="footerTitle">Service Areas:</h5>
          {(!selectedCityId || selectedCityId === 1) && (
            <>
              <h5 className="footerSubtitle">Houston and surrounding areas:</h5>
              <ul>
                <li>Katy*</li>
                <li>Cypress</li>
                <li>Woodlands*</li>
                <li>Sugar Land*</li>
                <li>Spring*</li>
                <li>Pasadena*</li>
                <li>Galveston*</li>
              </ul>
            </>
          )}
          {(!selectedCityId || selectedCityId === 2) && (
            <>
              <h5 className="footerSubtitle">Austin and surrounding areas:</h5>
              <ul>
                <li>Pflugerville</li>
                <li>Round Rock</li>
                <li>Manor*</li>
                <li>Leander</li>
                <li>Hutto</li>
                <li>Del Valle*</li>
                <li>Bee Cave*</li>
                <li>Lakeway*</li>
              </ul>
            </>
          )}
          {(!selectedCityId || selectedCityId === 5) && (
            <>
              <h5 className='footerSubtitle'>Denver and surrounding areas:</h5>
              <ul>
                <li>Denver</li>
                <li>Lakewood</li>
                <li>Golden</li>
                <li>Highlands Ranch</li>
                <li>Aurora</li>
                <li>Arvada</li>
                <li>Broomfield</li>
              </ul>
            </>
          )}
          {(!selectedCityId || selectedCityId === 3) && (
            <>
              <h5 className="footerSubtitle">Rio Grande Valley</h5>
              <ul>
                <li>Brownsville</li>
                <li>McAllen</li>
                <li>Edinburg</li>
                <li>Weslaco</li>
                <li>Pharr</li>
                <li>San Juan</li>
                <li>Alamo</li>
                <li>Mission</li>
                <li>Olmito</li>
                <li>San Benito</li>
                <li>La Joya</li>
                <li>Donna</li>
                <li>Mercedes</li>
                <li>Harlingen</li>
                <li>South Padre Island</li>
              </ul>
            </>
          )}
          {(!selectedCityId || selectedCityId === 6) && (
            <>
              <h5 className="footerSubtitle">San Antonio and surrounding areas:</h5>
              <ul>
                <li>New Braunfels*</li>
                <li>Schertz*</li>
                <li>Universal City*</li>
                <li>Live Oak*</li>
                <li>Converse*</li>
                <li>Windcrest*</li>
                <li>Alamo Heights*</li>
                <li>Terrell Hills*</li>
                <li>Olmos Park*</li>
              </ul>
            </>
          )}
          {(!selectedCityId || selectedCityId === 7) && (
            <>
              <h5 className="footerSubtitle">Nashville and surrounding areas:</h5>
              <ul>
                <li>Franklin*</li>
                <li>Madison*</li>
                <li>Belle Meade*</li>
                <li>Green Hills*</li>
                <li>Donelson*</li>
                <li>Hermitage*</li>
                <li>Antioch*</li>
                <li>Old Hickory*</li>
                <li>Oak Hill*</li>
                <li>Forest Hills*</li>
              </ul>
            </>
          )}
          {(!selectedCityId || selectedCityId === 9) && (
            <>
              <h5 className="footerSubtitle">Chicago and surrounding areas:</h5>
              <ul>
                <li>Evanston*</li>
                <li>Winnetka*</li>
                <li>Wilmette*</li>
                <li>Glencoe*</li>
                <li>Kenilworth*</li>
                <li>Glenview*</li>
                <li>Highland Park*</li>
                <li>Lake Forest*</li>
                <li>Park Ridge*</li>
                <li>Arlington Heights*</li>
                <li>Barrington*</li>
              </ul>
            </>
          )}
          {selectedCityId === 8 && (
            <>
              <h5 className="footerSubtitle">Dallas and surrounding areas:</h5>
              <ul>
                <li>Richardson*</li>
                <li>Plano*</li>
                <li>Addison*</li>
                <li>Farmers Branch*</li>
                <li>Carrollton*</li>
                <li>Garland*</li>
                <li>University Park*</li>
                <li>Highland Park*</li>
                <li>Lake Highlands*</li>
              </ul>
            </>
          )}
          *Travel fees may apply for areas outside of city centers. Exact fees sent at time of booking or available by phone.
        </div>
        
        <div className="footer-column">
        <h5 className="footerTitle">Call Us!</h5>
        <a href={`tel:${phoneNumber}`}>{phoneNumber}</a> <br/> <br/>
        <h5 className="footerTitle">Social</h5>
        <a href={instagramLink} aria-label="instagram">
          Instagram
        </a>
          <br/> <br/>
          <h5 className="footerTitle">Menu</h5>
          <p className="footerLinks">
            <a href="/weightloss">Weight loss injections</a><br/>
            <a href="/">Home</a><br/>
            <a href="/about">About</a><br/>
            <a href="/hangover">Hangover Drips</a><br/>
            <a href="/advanced-medicine">Advanced medicine Drips</a><br/>
            <a href="/hydration">Hydration Drips</a><br/>
            <a href="/workplace-hydration">Workplace hydration drips</a><br/>
            <a href="/sickness">Sickness Drips</a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p style={{ maxWidth: '740px', textAlign: 'center', margin: 'auto' }}>The services provided have not been evaluated by the Food and drug administration. These services are not intended to diagnose, treat, cure or prevent any disease. The material on this website is provided for informational purposes only and is not medical advice. Always consult your physician before starting any therapy program. © 2023 Luxe Mobile IV. Patient photos may be exchanged with stock photos to protect the privacy of our patients. </p>
        <a href="/luxe-mobile-iv-legal-policy.html">Legal Policy</a> | <a href="/luxe-mobile-iv-privacy-policy.html">Privacy Policy</a>
        <p>&copy; Copyright © {year} Luxe Mobile IV. All Rights Reserved.</p>
        <p>Booking software © {year}  <a href="https://www.andcounting.io/?utm__source=luxeWebsite&utm_medium=client">Patient Automation (dba AndCounting.IO). </a> All rights reserved. </p>
      </div>
    </section>
  );
};

export default FooterPage;
